import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { authApi, setAuthFlag, hasAuthFlag } from '../lib/api';
import { SITE } from '../mock';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Lock, User, Loader2 } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (hasAuthFlag()) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.login(username, password);
      setAuthFlag();
      toast.success('Welcome back, admin!');
      navigate('/admin');
    } catch (err) {
      toast.error('Login failed', { description: err.response?.data?.detail || 'Invalid credentials' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-marketplace min-h-screen grid place-items-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={SITE.logo} alt={SITE.name} className="h-20 w-20 mx-auto object-contain drop-shadow-lg" />
          <h1 className="mt-4 text-2xl font-bold bg-gradient-to-r from-amber-200 to-yellow-400 bg-clip-text text-transparent">
            {SITE.name}
          </h1>
          <p className="text-slate-400 text-sm mt-1">Admin Panel</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#111b38] border border-white/10 rounded-2xl p-8 space-y-5 shadow-2xl">
          <div>
            <Label className="text-slate-300">Username</Label>
            <div className="relative mt-1.5">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="pl-9 bg-white/5 border-white/10 text-white h-11"
                required
              />
            </div>
          </div>
          <div>
            <Label className="text-slate-300">Password</Label>
            <div className="relative mt-1.5">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-9 bg-white/5 border-white/10 text-white h-11"
                placeholder="Enter your password"
                required
              />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold">
            {loading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" />Signing in...</> : 'Sign in'}
          </Button>
          <p className="text-xs text-slate-500 text-center">Default: admin / Nagisa@2025</p>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
